import React = require('react');
import { Button, Col, ControlLabel, Row } from 'react-bootstrap';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { withRouter } from 'react-router';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import FieldFormControl from '../../../../components/FieldFormControl';
import { hasEmojis, isDobAFutureDate, isPostcode, isRequired, isValidDate } from '../../../../util/validators';
import { NextSteps } from './components/NextSteps'
import { FaSpinner } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import Loading from '../../../../components/Loading';
import { toastr } from 'react-redux-toastr'
import steps from '../../steps';
import { fromJsonApi } from '../../../../data/api/transformers/application';
import * as api from '../../../../data/api/api';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import Heap from '../../../../helpers/Heap';
import { windowSize } from '../../../../hooks/windowSize';


const QuoteFollowUp = ({ actions, match, handleSubmit, branding, dispatch, formValues }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customerName, setCustomerName] = useState('');

  const isMobile = windowSize(600).isMobile;

  const loadCustomerName = () => {
    actions.quote.retrieveQuoteOwnerFromId(match.params.id).then((data) => {
      setCustomerName(data.meta.first_name)
    })
  }

  const checkQuoteValidity = () => {
    actions.quote.checkQuoteValidity(match.params.id)
      .catch((err) => {
        redirectToQuoteJourney()
      });
  }

  useEffect(() => {
    Heap.track('QuoteFollowUp', {})

    setIsLoading(true)
    Promise.all([checkQuoteValidity(), loadCustomerName()])
      .finally(() => {
        setIsLoading(false)
      })
  }, []);

  const redirectToQuoteJourney = (quoteObject = null) => {
    if (quoteObject) {
      dispatch({ type: 'b2c/quote/RETRIEVE_QUOTE_FOR_JOURNEY', payload: { quoteObject } });
      dispatch({ type: 'b2c/quote/FAILED_QUOTE_RETRIEVAL', payload: false })

      api.getTrackingLinkByName('Quote Follow Up')
        .then((trackingLink) => {
          dispatch(actions.branding.setTrackingLink(trackingLink));
        })
    } else {
      dispatch({ type: 'b2c/quote/FAILED_QUOTE_RETRIEVAL', payload: true })
    }

    const quoteSteps = steps(branding.channel);
    actions.push(quoteSteps[0].route)
  }

  const onSubmit = (values) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true)

    actions.quote.retrieveQuoteWithValidation(
      match.params.id,
      values.dob,
      values.postcode
    )
      .then(({ data }) => {
        const quoteObject = fromJsonApi(data?.data, data?.included)
        quoteObject.steps.push('tripDeclaration')

        redirectToQuoteJourney(quoteObject)
      })
      .catch((err) => {
        if (err.response.status === 400) {
          if (err.response.data?.errors[0]?.title === 'Validation Failure') {
            return toastr.error(err.response.data.errors[0].detail)
          }
        }
        // If quote is not found/not valid, redirect to new quote page.
        redirectToQuoteJourney()
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  const welcomeTitle = () => {
    let title = 'Welcome back';

    if (customerName) {
      title += ', ' + customerName;
    }

    return title;
  }

  if (isLoading) {
    return (
      <Loading/>
    )
  }

  const renderForm = () => {
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="section-group validate-quote-details">
          <div className={'quote-card-title'} style={{ marginBottom: 0 }}>
            Please Confirm:
          </div>
          <div className={'section section-group-content'}>
            <Row className={'mb-8'}>
              <Col componentClass={ControlLabel} xs={6} className="full-width-xs">
                {branding.i18n.quote.tripDetails.traveller.dob}
              </Col>
              <Col xs={6} className="full-width-xs">
                <Field
                  name={`dob`}
                  type="masked-date"
                  inputMode="numeric"
                  component={FieldFormControl}
                  placeholder="dd/mm/yyyy"
                  className="form-control"
                  autoComplete="new-password"
                  validate={[
                    isRequired,
                    isValidDate,
                    isDobAFutureDate,
                  ]}
                />
              </Col>
            </Row>
            <Row className={'mb-8'}>
              <Col componentClass={ControlLabel} xs={6} className="full-width-xs">
                {branding.i18n.quote.tripDetails.traveller.postcode}
              </Col>
              <Col xs={6} className="full-width-xs">
                <Field
                  autocomplete="new-password"
                  name="postcode"
                  placeholder="Postcode"
                  type="text"
                  component={FieldFormControl}
                  validate={[
                    isRequired,
                    isPostcode,
                    hasEmojis,
                  ]}
                />
              </Col>
            </Row>
          </div>
          <div className="retrieve-button-wrapper">
            <Button
              type="submit"
              bsSize="lg"
              disabled={isSubmitting || (!formValues.dob || !formValues.postcode)}
            >
              {isSubmitting && (
                <FaSpinner className="fa-spin"/>
              )} RETRIEVE QUOTE NOW
            </Button>
          </div>
        </div>
        <div className="section-group">
          <div className={'quote-card-title'} style={{ marginBottom: 0 }}>
            Once you retrieve your quote:
          </div>
          <div className={'next-steps'}>
            <div>
              <NextSteps/>
            </div>
          </div>
        </div>
      </form>
    )
  }

  if (!isMobile) {
    return (
      <div className="internal-page">
        <div className="container quote-follow-up-container">
          <div className={'desktop-layout-container'}>
            <div className={'follow-up-banner-desktop'}>
                <img src={require('../../../../images/bannerImages/annie_desktop.png')} alt="Admiral"
                     className="follow-up-banner-annie"/>
            </div>
            <div className={'f-u-content-container-desktop'}>
              <div className={'welcome-back-message'}>{welcomeTitle()}</div>
              <h1>COMPLETE YOUR QUOTE NOW</h1>
              {renderForm()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="internal-page">
      <div className="container quote-follow-up-container">
        <div className={'welcome-back-message'}>{welcomeTitle()}</div>
        <h1>COMPLETE YOUR QUOTE NOW</h1>
        <div className={'follow-up-banner'}>
          <img src={require('../../../../images/bannerImages/annie-landing-page.png')} alt="Admiral"
               className="follow-up-banner-annie"/>
        </div>
        {renderForm()}
      </div>
    </div>
  )
}

let selector;

export default flow([
  reduxForm({
    form: 'quote_follow_up',
  }),
  (component) => {
    selector = formValueSelector('quote_follow_up');
    return component;
  },
  connect(
    (state: IStore) => {
      return {
        branding: state.branding,
        quote: state.quote,
        formValues: {
          dob: selector(state, 'dob'),
          postcode: selector(state, 'postcode')
        },
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
  withRouter,
])(QuoteFollowUp);

